import { ApolloProvider } from "@apollo/client";

import createClient from "../../services/apollo";

export const DataProvider: React.FC = ({ children }) => {
  return <ApolloProvider client={createClient()}>{children}</ApolloProvider>;
};
